<template>
  <div>
    <v-container fluid style="padding-bottom: 0">
      <v-text-field
        readonly
        placeholder="Presione para seleccionar la partida arancelaria"
        :value="nombrePartidaSelected"
        @click.prevent="showDialog = true"
        label="Partida arancelaria"
        :error-messages="errorMessages"
      ></v-text-field>
    </v-container>
    <v-dialog
      scrollable
      :fullscreen="$vuetify.breakpoint.mobile"
      v-model="showDialog"
    >
      <v-card>
        <v-card-title>
          <v-btn
            icon
            title="Cancelar"
            type="button"
            @click.native="showDialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
          Seleccionar la partida arancelaria
        </v-card-title>
        <v-text-field
          placeholder="Buscar"
          v-model="busqueda"
          :loading="loadingSearch"
          append-icon="search"
          clearable
          class="px-8"
        ></v-text-field>
        <v-card-text
          :class="{
            'fill-height': $vuetify.breakpoint.mobile,
            'partida-treeview': !$vuetify.breakpoint.mobile,
          }"
        >
          <div class="text-center">
            <v-progress-circular
              indeterminate
              v-if="loadingCapitulos"
            ></v-progress-circular>
          </div>
          <p
            v-if="
              busqueda &&
                busqueda.length > 0 &&
                partidasArancelarias.length === 0
            "
          >
            No se encontró resultados
          </p>
          <v-treeview
            :items="partidasArancelarias"
            item-key="codigo"
            :active="active"
            item-text="nombreResumido"
            :load-children="onChildrenLoad"
            hoverable
            transition
            open-on-click
            :open.sync="open"
            return-object
            @input="$emit('input', $event)"
           
          >
            <template v-slot:label="{ item, leaf, active, open }">
              <div @click="selectPartida(item)">
                <v-btn icon title="Seleccionar" v-if="leaf">
                  <v-icon>done</v-icon>
                </v-btn>
                {{ item.codigo }}{{ leaf ? item.digitoVerificador : "" }}.
                {{ item.nombreResumido }}
              </div>
            </template>
            <template v-slot:append="{ item, leaf }">
              <v-btn
                icon
                @click.stop="infoItem = item"
                v-if="item.nombreResumido.length !== item.nombreTecnico.length"
              >
                <v-icon>info</v-icon>
              </v-btn>
            </template>
          </v-treeview>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      @click:outside="infoItem = null"
      max-width="640px"
      :fullscreen="$vuetify.breakpoint.mobile"
      v-if="infoItem"
      :value="infoItem"
    >
      <v-card>
        <v-card-title>
          {{ infoItem.nombreResumido }}
        </v-card-title>
        <v-card-text
          class="text-center"
          style="white-space: pre; max-width: 100%"
        >
          {{ infoItem.nombreTecnico }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="infoItem = null">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import fieldMixin from "@/components/generic-fields/mixins/fieldMixin";
import debounce from "lodash.debounce";

export default {
  name: "SelectorPartidaArancelaria",
  mixins: [fieldMixin],
  data: () => ({
    open: [],
    showDialog: false,
    partidaSelected: null,
    infoItem: null,
    busqueda: null,
    busquedaCancelToken: null,
    loadingSearch: false,
  }),
  mounted() {
    this.obtenerCapitulos();
  },
  methods: {
    ...mapActions("partidasArancelarias", [
      "obtenerCapitulos",
      "obtenerHijos",
      "buscar",
    ]),
    onChildrenLoad(item) {
      return this.obtenerHijos(item.codigo);
    },
    selectPartida(item) {
      if (item.esHoja) {
        this.$emit("input", item);
        this.partidaSelected = item;
        this.showDialog = false;
      }
    },
  },
  watch: {
    value() {
      this.partidaSelected = this.value;
    },
    showDialog(val) {
      if (!val) {
        this.busqueda = null;
        this.obtenerCapitulos();
      }
    },
    busqueda: {
      handler: debounce(function(val, oldVal) {
        this.cancelToken && this.cancelToken.cancel();
        this.cancelToken = {};
        if (this.busqueda) {
          this.loadingSearch = true;
          this.buscar({
            busqueda: this.busqueda,
            cancelToken: this.cancelToken,
          }).then(
            () => (this.loadingSearch = false),
            () => {
              this.loadingSearch = false;
            }
          );
        } else {
          this.loadingSearch = false;
          this.obtenerCapitulos(this.cancelToken);
        }
      }, 350),
    },
  },
  computed: {
    ...mapState("partidasArancelarias", [
      "partidasArancelarias",
      "loadingCapitulos",
    ]),
    nombrePartidaSelected() {
      return this.partidaSelected
        ? `${this.partidaSelected.codigo}. ${this.partidaSelected.nombreResumido}`
        : null;
    },
    active() {
      return this.partidaSelected ? [this.partidaSelected.codigo] : [];
    },
  },
};
</script>

<style scoped>
.partida-treeview {
  height: 640px;
}
</style>
